module.exports = __webpack_public_path__ + "static/media/Header.253bd829.jpg";